import { Suspense } from "react";
import { Route, Routes } from "react-router";
import { PageLoading } from "~/components/loading";
import { CompoundRecordVersionsContainer } from "./components/compoundRecordVersions.container";

export function CompoundRecordVersionsRoutes() {
  return (
    <Suspense fallback={<PageLoading />}>
      <Routes>
        <Route index element={<CompoundRecordVersionsContainer />} />
      </Routes>
    </Suspense>
  );
}
